module.exports = __webpack_public_path__ + "static/media/8.e33ebf80.png";